export const COUNTDOWN_TITLE = 'Auction closes in';
export const AUCTION_CLOSED_MESSAGE = 'Auction closed';
export const BANNER_IMAGE_ALT = 'Campaign image';
export const MEDIUM_DESKTOP_BREAKPOINT = 'mediumDesktop';
